import { StyledLink } from '../../NavItem/NavItem.styled';
import sprite from '../../../../../assets/images/sprite.svg';
import { Wrapper, ArrowButton } from './DesktopAssortment.styled';
import { MouseEvent, useState } from 'react';
import { Menu } from '@mui/material';
import { AssortmentList } from '../AssortmentList/AssortmentList';

export const DesktopAssortment = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (e: MouseEvent<HTMLElement>)  => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Wrapper>
      <StyledLink to="/assortment">Продукти</StyledLink>
      <ArrowButton
        type="button"
        handleOpen={anchorEl}
        onClick={handleClick}
        aria-owns={open ? 'desktop-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <svg>
          <use href={`${sprite}#arrow-left`}></use>
        </svg>
      </ArrowButton>

      <Menu
        id="desktop-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        MenuListProps={{ disablePadding: true }}
        sx={{
          '& .MuiMenu-paper': {
            bgcolor: 'background.paper',
            width: '340px',
            padding: '12px',
            borderRadius: '20px',
            boxShadow: '0 12px 32px rgba(23, 26, 29, 0.14)',
          },
        }}
      >
        <AssortmentList />
      </Menu>
    </Wrapper>
  );
};
